import queryString from 'querystring';
import React from "react";
import { Translate, withLocalize } from "react-localize-redux";
import { withRouter } from 'react-router';
import { apiGet, getHostApi } from '../../store/apiWrapper';
import { isNullOrUndefined } from "../../store/storeFunctions";
import { Circles } from "../common/loadingComponent";
import Message from '../common/message';
import { isFirefox } from "../common/utils";

export const DOWNLOAD_FILE_TYPE = {
    chartsExport: "charts-export",
    conflictOfInterestClient: "conflict-of-interest-client",
    conflictOfInterestFile: "conflict-of-interest-file",
    conflictOfInterestReference: "conflict-of-interest-reference",
    conflictOfInterestXml: "conflict-of-interest-xml",
    industryAnalysis: "industry-analysis",
    marketingListExport: "marketing-list-export",
    marketingListNotFoundSubjects: "marketing-list-not-found",
    marketingListResult: "marketing-list-result",
    portfolioBulk: "portfolio-bulk",
    portfolioSubjects: "portfolio-subjects",
    ratioBook: "ratiobook",
    reportHistory: "reportHistory",
    reportPdf: "report-pdf",
    searchBulkError: "search-bulk-error",
    searchBulkResult: "search-bulk-result",
    skyMinder: "skyminder",
    customizableMsp: "customizable-msp"
}

class FilesComponent extends React.Component {

    state = {
        error: null,
        file: {
            fileName: null,
            webUrl: null
        }
    }

    componentDidMount() {
        this.downloadFile();
    }

    componentWillUnmount() {
        if (this.state.file && this.state.file.webUrl) {
            window.URL.revokeObjectURL(this.state.file.webUrl);
        }
    }

    render() {
        return (
            <div style={{ margin: "1em" }}>
                <a download href="#" style={{ display: 'none' }} id='downLnk'>D</a>
                {isNullOrUndefined(this.state.error) && isNullOrUndefined(this.state.file.fileName) && isNullOrUndefined(this.state.file.webUrl) && <Circles />}
                {!isNullOrUndefined(this.state.error) && <Message type="error" message={<Translate id="Common.File.NotFound" />} />}
                {!isNullOrUndefined(this.state.file.fileName) && !isNullOrUndefined(this.state.file.webUrl) &&
                    <Message type="info" message={<><Translate id="Common.File.Ready" />{" "}<a href={this.state.file.webUrl} download={this.state.file.fileName}><Translate id="Common.Here" /></a></>} />}
            </div>
        )
    }

    canDownload = () => {
        const params = this.props.match.params;

        switch (this.props.reportType) {
            case DOWNLOAD_FILE_TYPE.chartsExport:
            case DOWNLOAD_FILE_TYPE.conflictOfInterestFile:
            case DOWNLOAD_FILE_TYPE.portfolioBulk:
            case DOWNLOAD_FILE_TYPE.reportHistory:
            case DOWNLOAD_FILE_TYPE.searchBulkError:
            case DOWNLOAD_FILE_TYPE.reportPdf:
            case DOWNLOAD_FILE_TYPE.customizableMsp:
                return !isNullOrUndefined(params.guid);
            case DOWNLOAD_FILE_TYPE.conflictOfInterestClient:
            case DOWNLOAD_FILE_TYPE.conflictOfInterestReference:
                return true;
            case DOWNLOAD_FILE_TYPE.conflictOfInterestXml:
                return !isNullOrUndefined(params.transactionId);
            case DOWNLOAD_FILE_TYPE.industryAnalysis:
            case DOWNLOAD_FILE_TYPE.ratioBook:
                return !isNullOrUndefined(params.year) && !isNullOrUndefined(params.name);
            case DOWNLOAD_FILE_TYPE.marketingListExport:
            case DOWNLOAD_FILE_TYPE.marketingListNotFoundSubjects:
            case DOWNLOAD_FILE_TYPE.marketingListResult:
                return !isNullOrUndefined(params.requestId);
            case DOWNLOAD_FILE_TYPE.portfolioSubjects:
                return !isNullOrUndefined(params.portfolioId);
            case DOWNLOAD_FILE_TYPE.searchBulkResult:
                return !isNullOrUndefined(params.registry) && !isNullOrUndefined(params.bulkId);
            case DOWNLOAD_FILE_TYPE.skyMinder:
                return !isNullOrUndefined(params.type);
            default: return false;
        }
    }

    getUrl = () => {
        const hostApi = getHostApi();
        const params = this.props.match.params;

        switch (this.props.reportType) {
            case DOWNLOAD_FILE_TYPE.chartsExport: return `${hostApi}/api/charts/export/download/${params.guid}`;
            case DOWNLOAD_FILE_TYPE.conflictOfInterestClient: return `${hostApi}/api/conflict-of-interest/client/export?${queryString.stringify({ sortBy: params.sortBy })}`;
            case DOWNLOAD_FILE_TYPE.conflictOfInterestFile: return `${hostApi}/api/conflict-of-interest/file/${params.guid}`;
            case DOWNLOAD_FILE_TYPE.conflictOfInterestReference: return `${hostApi}/api/conflict-of-interest/reference/export?${queryString.stringify({ sortBy: params.sortBy })}`;
            case DOWNLOAD_FILE_TYPE.conflictOfInterestXml: return `${hostApi}/api/conflict-of-interest/xml/${params.transactionId}`;
            case DOWNLOAD_FILE_TYPE.industryAnalysis: return `${hostApi}/api/industry-analysis/document/${params.year}/${params.name}/IA`;
            case DOWNLOAD_FILE_TYPE.marketingListExport: return `${hostApi}/api/marketing-list/get-export/${params.requestId}`;
            case DOWNLOAD_FILE_TYPE.marketingListNotFoundSubjects: return `${hostApi}/api/marketing-list/not-found-subjects/${params.requestId}`;
            case DOWNLOAD_FILE_TYPE.marketingListResult: return `${hostApi}/api/marketing-list/result/${params.requestId}`;
            case DOWNLOAD_FILE_TYPE.portfolioBulk: return `${hostApi}/api/portfolio/bulk/not-found/${params.guid}`;
            case DOWNLOAD_FILE_TYPE.portfolioSubjects: return `${hostApi}/api/portfolio/${params.portfolioId}/subjects/export`;
            case DOWNLOAD_FILE_TYPE.ratioBook: return `${hostApi}/api/ratiobook/document/${params.year}/${params.name}/RB`;
            case DOWNLOAD_FILE_TYPE.reportHistory: return `${hostApi}/api/account/report-history/csv/${params.guid}`;
            case DOWNLOAD_FILE_TYPE.reportPdf: return `${hostApi}/api/report/get-pdf/${params.guid}`;
            case DOWNLOAD_FILE_TYPE.searchBulkError: return `${hostApi}/api/search/bulk/error/${params.guid}`;
            case DOWNLOAD_FILE_TYPE.searchBulkResult: return `${hostApi}/api/search/${params.registry}/bulk/${params.bulkId}`;
            case DOWNLOAD_FILE_TYPE.skyMinder: return `${hostApi}/api/domain/service-data?type=${params.type}`;
            case DOWNLOAD_FILE_TYPE.customizableMsp: return `${hostApi}/api/excel-export/customizable-msp/${params.guid}`;
            default: return null;
        }
    }

    downloadFile() {
        if (!this.canDownload()) {
            this.setState({ error: "Invalid input parameters!" });
            return;
        }

        const url = this.getUrl();
        if (!isNullOrUndefined(url)) {
            apiGet(url, null,
                (response) => {
                    if (response.error) {
                        const { code } = response.error;
                        if (code !== 200)
                            this.setState({ error: `Error with code: ${code}` });
                    } else {
                        const { data, contentType, fileName } = response.data;
                        const uint8Array = new Uint8Array(atob(data).split('').map(char => char.charCodeAt(0)));
                        const blob = new Blob([uint8Array], { type: contentType });
                        const webUrl = window.URL.createObjectURL(blob);
                        this.setState({ file: { fileName: fileName, webUrl: webUrl } });

                        var downloadLink = document.getElementById("downLnk");
                        downloadLink.href = webUrl;
                        downloadLink.download = fileName;
                        downloadLink.click();

                        if (isFirefox())
                            setTimeout(function () { window.close(); }, 1000);
                        else
                            window.close(); //Scripts may close only the windows that were opened by them.
                    }
                },
                (e) => {
                    this.setState({ error: e });
                }
            )
        }
    }
}

export default withLocalize(withRouter(FilesComponent));
